import { useState, useRef, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { namespaceState } from '../../../recoil/atoms';
import styles from './TagsTab.module.css';
import SearchBar from '../../../compoenets/SearchBar';
import useApi from '../../../services/useApi';


export default function TagsTab({filter,onChange}){
    const [nsState,setNsState]=useRecoilState(namespaceState);
    const MAX_RECOMMEND_SHOW=5;
    const [tagsData,setTagsData]=useState([]);
    const searchRef=useRef(null);
    const recommendRef=useRef(null);
    const selectedRef=useRef(null);
    const [searchedTags,setSearchedTags]=useState(tagsData.slice(0,MAX_RECOMMEND_SHOW));
    const [resultsText,setResultsText]=useState("Recommend")
    const [isFocus,setIsFocus]=useState(false);

    useEffect(()=>{
        useApi.get('/ngp/modelreg/mm/model/v1/search/tags?namespaceId='+nsState.id)
        .then((res) => {
            setTagsData(res.data);
            setSearchedTags(res.data);
        })
        document.addEventListener('mousedown',handleSearchBlur);
        return ()=>{
            document.removeEventListener('mousedown',handleSearchBlur)
        }
    },[])

    const handleInputChange=(value)=>{
        if(value.trim()===""){
            setResultsText("Recommend")
            setSearchedTags(tagsData.slice(0,MAX_RECOMMEND_SHOW));
            return;
        }

        if(value.trim()!==""){
            setResultsText("Searches")
            setSearchedTags(
                tagsData.filter((tag)=>tag.toLowerCase().includes(value.toLowerCase()))
            )
        }
    }

    const handleInputClear=()=>{
        handleInputChange("");
    }

    const handleTagClick=(e,item)=>{
        searchRef.current?.focus();
        onChange("tags",item);
    }

    const handleSearchBlur=(e)=>{
        if(
            (searchRef.current===document.activeElement)&&
            !recommendRef.current.contains(e.target)&&
            !selectedRef.current.contains(e.target) 
        ){
            setIsFocus(false)
        }
    }

    const handleTagList=(e)=>{
        if(recommendRef.current.contains(e.target)){
            searchRef.current.focus();
        }
    }

    return(
        <>
        <SearchBar
        ref={searchRef}
        wrapStyle={`${styles['search']} ${isFocus && styles['search-on']}`}
        inputStyle={styles['search-input']}
        iconStyle={styles['icon-style']}
        placeholder='Search tag'
        onFocus={()=>setIsFocus(true)}
        onBlur={handleSearchBlur}
        onChange={handleInputChange} 
        onClear={handleInputClear}
        />
        <div 
        className={`${styles['section']} ${styles['section-hide']} ${isFocus&&styles['section-show']}`}
        ref={recommendRef}
        onClick={handleTagList}>
            <div className={styles['section-header']}>
                <span>{resultsText}</span>
            </div>
            <div 
            className={`${styles['recommend-body']} ${styles['section-body']}`}
            onMouseDown={()=>searchRef.current?.focus()}>
                {searchedTags.map(item=>
                <div 
                className={styles['row-wrap']}
                key={item}
                onMouseDown={(e)=>handleTagClick(e,item)}>
                    <div className={`${styles['row-title']} ${filter.filters.tags.includes(item)&&styles['row-selected']}`}>
                        <span>{item}</span>
                    </div>
                    <span>Auto Tag</span>
                </div>
                )}
            </div>
        </div>
        <div 
        className={styles['section']}
        ref={selectedRef}>
            <div className={styles['section-header']}>
                <span>Selected Tags</span>
            </div>
            <div 
            className={`
                ${styles['selected-body']} 
                ${styles['section-body']} 
                ${filter.filters.tags.length==0 && styles['selected-body-background']}`}>
                {filter.filters.tags.map(item=>
                <div className={styles['item-wrap']}>
                    <p className={styles['item-name']}>
                        <span>{item}</span>
                    </p>
                    {/* <div className={styles['item-type']}>{toUpperFirstCase(data.namespaceUserRoleName)}</div> */}
                    <div className={styles['item-remove']} onClick={()=>onChange('tags',item)}></div>
                </div>
                )}
            </div>
        </div>
        </>
    )
}